import React from 'react';
import MetaHelmet from '../../components/MetaHelmet';
import Header from '../../components/Header';
import backgroundImage from '../../../assets/Images/homepage_header.png';
import BeginActivity from '../../container/Home/beginActivity';
import ModelInstructions from '../../container/Home/modelInstructions';
import HowToComplete from '../../container/Home/howToComplete';
import Partners from '../../container/Home/partners';
import Footer from '../../components/footer';
import InformationButton from '../../components/informationButton';

const Home = () => (
  <>
    <MetaHelmet
      title="Act Early on Chronic Kidney Disease Treatment"
      description="Explore how your treatment approach can influence the progression of kidney disease and benefit your patients."
    />
    <header
      className="background-header"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Header />
      <InformationButton />
      <div
        className="grid-container width-100 padding-horizontal-2"
        style={{ paddingTop: '10rem', paddingBottom: '5rem' }}
      >
        <div className="padding-vertical-3 text-left">
          <h1 className="font-semibold white-color">
            Act Early on <br />
            Chronic Kidney Disease <br />
            Treatment
          </h1>
        </div>
      </div>
    </header>
    <BeginActivity />
    <ModelInstructions />
    <HowToComplete />
    <Partners />
    <Footer />
  </>
);

export default Home;
